<template>
  <div id="app">
    <a-config-provider :locale="ru">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import ru from 'ant-design-vue/lib/locale-provider/ru_RU';

export default {
  data() {
    return {
      ru,
    };
  },
};
</script>

<style lang="scss">
@import "reset-css";
@import "~bootstrap/scss/_functions";
@import "~bootstrap/scss/_variables";
@import "~bootstrap/scss/_mixins";
@import "~bootstrap/scss/_root";
@import "~bootstrap/scss/_type";
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900&display=swap&subset=cyrillic");

body {
  font-family: "Roboto", sans-serif;
}

strong {
  font-weight: bold;
}

em {
  font-style: italic;
}

td {
  vertical-align: top;
}

.table-img {
  max-width: 400px;
}
</style>
